import { commonTranslations } from './admin/common';
import { orders } from './admin/orders';
import { settingsTranslations } from './admin/settings';
import { categoryTranslations } from './admin/categories';
import { menuTranslations } from './admin/menu';
import { iconPickerTranslations } from './admin/iconPicker';
import { navigationTranslations } from './admin/navigation';
import { itemTranslations } from './admin/items';
import { userTranslations } from './admin/users';
import { printerTranslations } from './admin/printers';

export const adminTranslations = {
    en: {
        ...commonTranslations.en,
        ...orders.en,
        ...settingsTranslations.en,
        ...categoryTranslations.en,
        ...menuTranslations.en,
        ...iconPickerTranslations.en,
        ...navigationTranslations.en,
        ...itemTranslations.en,
        ...userTranslations.en,
        ...printerTranslations.en
    },
    ar: {
        ...commonTranslations.ar,
        ...orders.ar,
        ...settingsTranslations.ar,
        ...categoryTranslations.ar,
        ...menuTranslations.ar,
        ...iconPickerTranslations.ar,
        ...navigationTranslations.ar,
        ...itemTranslations.ar,
        ...userTranslations.ar,
        ...printerTranslations.ar
    }
};